var ShopFilterBar = {
  init: function () {
    $(".before-shop-loop .woocommerce-widget-layered-nav-list__item").on(
      "click",
      function () {
        // $(".show-results").trigger("click");
      }
    );
  },
};

$(window).load(function () {
  if ($(".before-shop-loop .woocommerce-widget-layered-nav-list").length) {
    ShopFilterBar.init();
  }
});
